<template>
  <div class="carrinho-compras" v-if="!temPagamentoPendente">
    <router-link class="nav-link" to="/carrinho">
      <p title="Carrinho"><i class="fa fa-shopping-cart mt-1"></i></p>
      <span class="quantidade-itens align-items-center justify-content-center translate-middle badge rounded-pill bg-secondary" v-if="possuiItensCarrinho">
        {{totalItens()}}
      </span>
    </router-link>
  </div>
</template>

<script>
import CarrinhoCompras from './js'
export default CarrinhoCompras
</script>

<style scoped>
@import "./scss/CarrinhoCompras.scss";
</style>
